import { useCallback, useMemo } from "react"

export function useAnalytics(screen: string)
{
	let sendEvent = useCallback((event: string) =>
	{
		gtag("event", event, {
			app_name: "WebReportGenerator",
			screen_name: screen,
		})
	}, [])
	let ret = useMemo(() => ({ sendEvent }), [sendEvent])
	return ret
}